interface Country {
    code: string,
    label: string,
    __typename: 'CartAddressCountry'
};

interface Region {
    code: string,
    label: string,
    __typename: 'CartAddressRegion'
};

interface ShippingAddress {
    street: string[],
    __typename: "ShippingCartAddress",
    city: string,
    company: string,
    country: Country,
    firstname: string,
    lastname: string,
    postcode: string,
    region: Region,
    telephone: string
}

const shippingAddress: ShippingAddress = {
    street: ["Rua Cantareira", "306", "Centro Histórico de São Paulo", "ND"],
    __typename: "ShippingCartAddress",
    city: "Sao Paulo",
    company: "743",
    country: {
        code: "BR",
        label: "BR",
        __typename: "CartAddressCountry",
    },
    firstname: "Roberto Carlos",
    lastname: "da Silva",
    postcode: "01024900",
    region: {
        code: "SP",
        label: "São Paulo",
        __typename: "CartAddressRegion",
    },
    telephone: "11993336458",
};

export default shippingAddress;